import { render } from "./Admin.vue?vue&type=template&id=1be0181c&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=1be0181c&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be0181c"]])

export default __exports__